export default function SellingPlan (props) {
  const sellingPlanAllocation = props.selling_plan_allocations && props.selling_plan_allocations[0]
  const priceAdjustments = sellingPlanAllocation.price_adjustments
  const sellingPlanName = sellingPlanAllocation.selling_plan && sellingPlanAllocation.selling_plan.name
  const priceAdjustment = priceAdjustments && priceAdjustments[0].price && (priceAdjustments[0].price / 100).toFixed(2) + ' a month'
  const price = sellingPlanName || priceAdjustment
  const self = {
    id: sellingPlanAllocation.selling_plan_id,
    price: price && price.replace('$', '')
  }

  return Object.assign({}, props, self)
}
